import { siteInfo } from '@/mocks/chiguaData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[700px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            投稿爆料
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mb-8">
            {siteInfo.contact.description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={`mailto:${siteInfo.contact.email}`}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line text-lg"></i>
              {siteInfo.contact.email}
            </a>
            <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 border border-background-300 text-foreground-700 font-medium text-sm whitespace-nowrap">
              <i className="ri-wechat-line text-lg"></i>
              微信：{siteInfo.contact.wechat}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}